import {
  Box,
  Card,
  CardContent,
  List,
  ListItem,
  Stack,
  ToggleButton,
  Typography,
} from '@mui/material';

import InfoTooltipIcon from '@/components/icons/InfoTooltipIcon';
import { formatHour } from '@/utils/formatters';

const EnergyGroupInfoCard = ({
  title,
  description,
  selectedEnergyGroup,
  locationData,
}) => {
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Stack
          direction="column"
          color="inherit"
          elevation={0}
          sx={{
            transition: 'box-shadow 0.3s ease',
            background: 'transparent',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  fontWeight="bold"
                >
                  {title}
                </Typography>
                <InfoTooltipIcon title={description} />
              </Box>
            </Box>
          </Box>

          <List dense disablePadding sx={{ mt: 2 }}>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Adresse:</Box>
              <Box>{locationData?.displayName}</Box>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: 'bold' }}>Åbningstider:</Typography>
              <Typography>
                {formatHour(selectedEnergyGroup.options?.workingDayStart)} -{' '}
                {formatHour(selectedEnergyGroup.options?.workingDayEnd)}
              </Typography>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography sx={{ fontWeight: 'bold' }}>Åbningsdage:</Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                }}
              >
                {[
                  { key: 'monday', label: 'M' },
                  { key: 'tuesday', label: 'T' },
                  { key: 'wednesday', label: 'O' },
                  { key: 'thursday', label: 'T' },
                  { key: 'friday', label: 'F' },
                  { key: 'saturday', label: 'L' },
                  { key: 'sunday', label: 'S' },
                ].map(({ key, label }) => (
                  <ToggleButton
                    key={key}
                    value={key}
                    disabled={true}
                    selected={selectedEnergyGroup?.options?.daysOfWeek[key]}
                    // onChange={() => handleDayToggle(key)}
                    sx={{
                      width: 28,
                      height: 28,
                      borderRadius: 1,
                      fontWeight: 'bold',
                      p: 0,
                      '&.Mui-selected': {
                        backgroundColor: '#52b202',
                        color: 'white',
                        // '&:hover': {
                        //   backgroundColor: darken('#4CAF50', 0.1),
                        // },
                      },
                    }}
                  >
                    {label}
                  </ToggleButton>
                ))}
              </Box>
            </ListItem>
          </List>
          {/* <List>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Energigruppe:</Box>
              <Box>{selectedEnergyGroup.name}</Box>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Adresse:</Box>
              <Box>{locationData.displayName}</Box>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Initiativer:</Box>
              <Box>
                {selectedEnergyGroup.energyInitiatives.length > 0
                  ? selectedEnergyGroup.energyInitiatives.length
                  : 'Ingen initiativer fundet'}
              </Box>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Noder:</Box>
              <Box>
                {selectedEnergyGroup.energyTreeNodes.length > 0
                  ? selectedEnergyGroup.energyTreeNodes.length
                  : 'Ingen noder fundet'}
              </Box>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Åbningstid:</Box>
              <Box>
                {selectedEnergyGroup.options.workingDayStart} -{' '}
                {selectedEnergyGroup.options.workingDayEnd}
              </Box>
            </ListItem>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Box sx={{ fontWeight: 'bold' }}>Synkroniserings status:</Box>
              <Box>{selectedEnergyGroup.options.state}</Box>
            </ListItem>
          </List> */}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default EnergyGroupInfoCard;
